import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import stylesTableDarkMode from '../styles/TableDarkMode'
import stylesTableLightMode from '../styles/TableLightMode'
import Item from '../elementos/Item';
import Categoria from '../elementos/Categoria';

export default function CategoriaItem({ elem, notasPadre = null }) {

    const { darkMode } = useDarkMode();

    const dynamicStyles = darkMode ? stylesTableDarkMode : stylesTableLightMode;

    return (
        <ul style={{ listStyle: 'none', paddingLeft: 10, margin: '4px 0' }}>
            <li style={{ margin: 0 }}>
                {Object.keys(elem.hijos).map((key, index) => {
                    const hijo = elem.hijos[key]
                    const notasContexto = hijo?.notas ?? elem?.notas ?? notasPadre
                    return (
                        hijo.tipo === "item" ?
                            <Item key={index} elem={hijo} notasPadre={notasContexto} />
                            :
                            hijo.tipo === "categoria" &&
                            <Categoria key={index} elem={hijo} notasPadre={notasContexto} />

                    )
                })}
            </li>
        </ul>
    )
}